import React from 'react'
import { graphql, Link, PageProps } from 'gatsby'
// import loadable from '@loadable/component'
import Breadcrumbs from '../components/primitives/breadcrumbs'
import Row from '../components/primitives/grid/row'
import Col from '../components/primitives/grid/col'
import Container from '../components/primitives/grid/container'
import StyledForm from '../components/primitives/styled-form'
import StyledFormInput from '../components/primitives/styled-form/styled-form-input'
import StyledFormSelect, {
    StyledFormSelectOption,
} from '../components/primitives/styled-form/styled-form-select'
import { Radio, RadioGroup } from '../components/primitives/radio'
import Download from '../components/blocks/basic/download'
import StyledButton from '../components/primitives/styled-button'
import Avatar from '../components/primitives/avatar'
import normalizePersonFields from '../utils/normalize-person-fields'
import { WPImage } from '../components/primitives/image/gatsby-image-svg-fallback'
import WpJobSvg from '../images/wpJob-background.svg'
import formatDate from '../utils/format-date'
// const StyledFormFile = loadable(import('../components/primitives/styled-form/styled-form-file'))
import StyledFormFile from '../components/primitives/styled-form/styled-form-file'
import StyledLink from '../components/primitives/styled-link'
import SEO from '../components/SEO'

export const Head: React.FC<{ data: any }> = ({ data }) => {
    const post = data.wpPage
    return <SEO post={post} title={post?.seo?.title} />
}

const WpJob = ({
    data,
}: PageProps<Queries.WpJobPageQuery>): React.ReactElement => {
    const post = data.wpJob
    if (!post) {
        return <div className="spinner">Loading...</div>
    }
    const date = new Date(post?.date || new Date())
    const applicationTime = post?.jobDetails?.applicationTime
        ? new Date(post?.jobDetails?.applicationTime)
        : null

    const breadcrumbs = post && post.seo?.breadcrumbs

    return (
        <div css={{ width: '100%', overflowX: 'hidden' }}>
            {breadcrumbs && breadcrumbs.length > 0 && (
                <Breadcrumbs
                    crumbs={[
                        { text: 'Beruf und Karriere', url: '/job' },
                    ].concat(breadcrumbs[breadcrumbs.length - 1])}
                    sliceFirst={false}
                />
            )}

            <div
                css={{
                    position: 'relative',
                    background: '#f3f3f3',
                    overflow: 'hidden',
                }}
            >
                <div
                    css={{
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'flex-end',
                    }}
                >
                    <WpJobSvg />
                </div>
                <Container
                    css={{
                        padding: '82px 0',
                        '@media (max-width: 767px)': {
                            padding: '48px 22px',
                        },
                    }}
                >
                    <Row>
                        <Col
                            breakpoints={{ dt: { span: 12 }, mb: { span: 4 } }}
                        >
                            <div className="p1">
                                {post?.jobDetails?.worktime?.includes(
                                    'fulltime'
                                )
                                    ? `Vollzeit${
                                          post?.jobDetails?.fulltimeDescription
                                              ? ` - ${post?.jobDetails?.fulltimeDescription}`
                                              : ''
                                      }`
                                    : ''}
                                {post?.jobDetails?.worktime?.includes(
                                    'fulltime'
                                ) &&
                                post?.jobDetails?.worktime?.includes('parttime')
                                    ? ' / '
                                    : ''}
                                {post?.jobDetails?.worktime?.includes(
                                    'parttime'
                                )
                                    ? `Teilzeit${
                                          post?.jobDetails?.parttimeDescription
                                              ? ` - ${post?.jobDetails?.parttimeDescription}`
                                              : ''
                                      }`
                                    : ''}
                                {(post?.jobDetails?.worktime?.includes(
                                    'fulltime'
                                ) ||
                                    post?.jobDetails?.worktime?.includes(
                                        'parttime'
                                    )) &&
                                    applicationTime &&
                                    ' • '}
                                {applicationTime &&
                                    'Bewerbungsfrist bis ' &&
                                    formatDate(applicationTime, '.')}
                            </div>
                            <h1 className="h0" css={{ marginTop: '19px' }}>
                                {post?.title}
                            </h1>
                            {/* <p className='p1' css={{ marginTop: '12px' }}>
                                Klinik in Chemnitz
                            </p> */}
                        </Col>
                    </Row>
                </Container>
            </div>
            <div css={{ backgroundColor: '#f6f6f6' }}>
                <Container>
                    <Row>
                        <Col
                            breakpoints={{
                                dt: { span: 8, rightGap: 'full' },
                                tb: { span: 6, rightGap: 'full' },
                            }}
                            css={{
                                height: 'auto',
                                minHeight: '30vw',
                                display: 'flex',
                                position: 'relative',
                                flexDirection: 'column',
                                width: '100%',
                                '@media (max-width: 767px)': {
                                    order: 1,
                                    width: '100%',
                                    height: '257px',
                                    maxHeight: 'auto',
                                    left: '0',
                                },
                            }}
                        >
                            <WPImage
                                {...(data?.wp?.jobOptions?.joboptionen
                                    ?.bild as any)}
                                css={{
                                    height: '100%',
                                    width:
                                        'max(calc(100vw - 1440px / 1.6), 1440px)',
                                    '@media (max-width: 767px)': {
                                        width: '100%',
                                    },
                                    right: '0',
                                    position: 'absolute',
                                }}
                            />
                        </Col>
                        <Col
                            breakpoints={{ dt: { span: 4 }, tb: { span: 6 } }}
                            css={{
                                height: 'auto',
                                display: 'flex',
                                position: 'relative',
                                paddingLeft: '44px',
                                paddingRight: '44px',
                                paddingBottom: '47px',
                                paddingTop: '51px',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                '@media (max-width: 1200px)': {
                                    padding: '32px',
                                },
                                '@media (max-width: 767px)': {
                                    order: 2,
                                    width: '100%',
                                    maxHeight: 'auto',
                                    paddingLeft: '38px',
                                    paddingRight: '38px',
                                },
                            }}
                        >
                            <h3 className="h2">
                                {data?.wp?.jobOptions?.joboptionen?.title}
                            </h3>
                            <div
                                className="p2 ql-editor"
                                css={{
                                    marginTop: '28px',
                                    textAlign: 'justify',
                                }}
                                dangerouslySetInnerHTML={{
                                    __html:
                                        data?.wp?.jobOptions?.joboptionen
                                            ?.text || '',
                                }}
                            />
                        </Col>
                    </Row>
                </Container>
            </div>
            <Container css={{ paddingTop: '47px', paddingBottom: '97px' }}>
                <p className="p2">veröffentlicht am {formatDate(date, '.')}</p>
                <div
                    className="ql-editor p1"
                    css={{ width: '100%', marginTop: '25px' }}
                    dangerouslySetInnerHTML={{ __html: post?.content || '' }}
                />
                <div css={{ width: '100%', marginTop: '30px' }}>
                    <p className="p1">
                        Senden Sie Ihre vollständigen Bewerbungsunterlagen an:{' '}
                        {/* @ts-ignore */}
                        <Link
                            to={`mailto:${post?.jobDetails?.mail}`}
                            css={{
                                color: '#174874',
                                textDecoration: 'underline',
                            }}
                        >
                            {post?.jobDetails?.mail}
                        </Link>
                    </p>
                    <p className="p1">oder schriftlich an:</p>
                    <div
                        className="p1"
                        css={{ marginTop: '30px' }}
                        dangerouslySetInnerHTML={{
                            __html: post?.jobDetails?.address || '',
                        }}
                    />
                </div>
                <StyledForm
                    prepareForSubmit={e => ({
                        ...e,
                        job_id: post?.databaseId,
                    })}
                    endpoint={`https://${process.env.GATSBY_WP_URL}/wp-json/drk/v1/jobs/apply`}
                    submitButtonText="Absenden"
                    borderTop={false}
                    asFormData
                >
                    <StyledFormSelect
                        required
                        name="salutation"
                        placeholder="Anrede"
                    >
                        <StyledFormSelectOption value="Herr">
                            Herr
                        </StyledFormSelectOption>
                        <StyledFormSelectOption value="Frau">
                            Frau
                        </StyledFormSelectOption>
                        <StyledFormSelectOption value="nein">
                            Nein
                        </StyledFormSelectOption>
                    </StyledFormSelect>
                    <StyledFormInput name="name" placeholder="Name" required />
                    <StyledFormInput
                        name="email"
                        placeholder="E-Mail"
                        type="email"
                        required
                    />
                    <StyledFormInput
                        name="telephone"
                        placeholder="Telefon (optional)"
                        type="tel"
                    />
                    <StyledFormInput
                        name="message"
                        placeholder="Ihre Nachricht (optional)"
                    />
                    <StyledFormFile name="documents" />
                    {data?.wp?.jobOptions?.alljoboptionen?.woher?.length >
                        0 && (
                        <StyledFormSelect
                            required
                            name="woher"
                            placeholder="Wie hast du von uns erfahren?"
                        >
                            {data?.wp?.jobOptions?.alljoboptionen?.woher?.map(
                                obj =>
                                    obj?.text && (
                                        <StyledFormSelectOption
                                            value={obj?.text}
                                        >
                                            {obj?.text}
                                        </StyledFormSelectOption>
                                    )
                            )}
                        </StyledFormSelect>
                    )}
                    <RadioGroup name="radio" required>
                        <Radio sizes="lg" value="terms">
                            Ich habe die{' '}
                            <StyledLink to="/datenschutzerklaerung/">
                                Datenschutzbestimmungen
                            </StyledLink>{' '}
                            gelesen und akzeptiere diese.
                        </Radio>
                    </RadioGroup>
                </StyledForm>
                <div
                    css={{
                        paddingBottom: '22px',
                        marginTop: '47px',
                        borderBottomWidth: '1px',
                        borderStyle: 'solid',
                        borderColor: 'var(--color-gray-mittelgrau)',
                    }}
                >
                    {post?.jobDetails?.cantactPerson && (
                        <div css={{ width: '100%', marginBottom: '26px' }}>
                            <p className="h4">
                                Bei Rückfragen wenden Sie sich bitte an:{' '}
                            </p>
                            <div
                                css={{
                                    display: 'flex',
                                    flexFlow: 'wrap',
                                    paddingTop: '23px',
                                    paddingBottom: '60px',
                                }}
                            >
                                {post?.jobDetails?.cantactPerson
                                    .map(x => normalizePersonFields(x))
                                    .map((employee, index) => (
                                        <div
                                            css={{
                                                width: '50%',
                                                paddingBottom: '40px',
                                                paddingRight: '40px',
                                                '@media (max-width: 767px)': {
                                                    width: '100%',
                                                    paddingBottom: '0',
                                                    paddingRight: '0',
                                                },
                                            }}
                                            key={employee?.id || index}
                                        >
                                            <Avatar
                                                name={employee?.title}
                                                image={
                                                    employee?.featuredImage
                                                        ?.node
                                                }
                                                job={
                                                    employee?.contactFields?.job
                                                }
                                                jobDescription={
                                                    employee?.contactFields
                                                        ?.jobDescription
                                                }
                                                contact={
                                                    employee?.contactFields
                                                        ?.contact
                                                }
                                                einrichtung={
                                                    employee?.contactFields
                                                        ?.einrichtung
                                                }
                                                hasSingle={
                                                    employee?.contactFields
                                                        ?.singlePage
                                                }
                                                link={employee?.link}
                                            />
                                        </div>
                                    ))}
                            </div>
                        </div>
                    )}

                    {post?.jobDetails?.download && (
                        <div>
                            <h2 className="h2" css={{ paddingBottom: '32px' }}>
                                Jetzt Stellenbeschreibung downloaden
                            </h2>
                            <Download
                                file={{
                                    href:
                                        post?.jobDetails?.download?.localFile
                                            ?.publicURL || '',
                                }}
                                title={post?.jobDetails?.download?.title || ''}
                                css={{
                                    paddingLeft: '0!important',
                                    paddingRight: '0!important',
                                }}
                            />
                        </div>
                    )}
                </div>
                <div css={{ padding: '51px 0px 94px' }}>
                    <div css={{ maxWidth: '213px', width: '100%' }}>
                        <StyledButton to="/job" theme="secondary" arrowLeft>
                            Zurück
                        </StyledButton>
                    </div>
                </div>
            </Container>
        </div>
    )
}
export default WpJob

export const query = graphql`
    query WpJobPage($id: String) {
        wpJob(id: { eq: $id }) {
            id
            uri
            title
            status
            slug
            date
            dateGmt
            databaseId
            contentTypeName
            content
            jobDetails {
                address
                applicationTime
                fulltimeDescription
                parttimeDescription
                mail
                worktime
                cantactPerson {
                    ... on WpContactPerson {
                        id
                        title
                        link
                        contactPersonDetails {
                            job
                            jobDescription
                            address {
                                house
                                city
                                line1
                                street
                            }
                            building
                            educationAuthorization
                            contact {
                                fax
                                phone
                                title
                                email
                            }
                            publications
                            singlePage
                            focus {
                                item
                            }
                        }
                        featuredImage {
                            node {
                                altText
                                localFile {
                                    childImageSharp {
                                        gatsbyImageData(quality: 100)
                                    }
                                }
                            }
                        }
                    }
                }
                download {
                    title
                    localFile {
                        publicURL
                    }
                }
            }
            seo {
                breadcrumbs {
                    text
                    url
                }
                title
                metaDesc
                focuskw
                metaKeywords
                opengraphTitle
                opengraphDescription
                opengraphImage {
                    altText
                    sourceUrl
                    srcSet
                }
                twitterTitle
                twitterDescription
                twitterImage {
                    altText
                    sourceUrl
                    srcSet
                }
                canonical
                cornerstone
                schema {
                    articleType
                    pageType
                    raw
                }
                metaRobotsNofollow
                metaRobotsNoindex
            }
        }
        wp {
            jobOptions {
                joboptionen {
                    title
                    text
                    bild {
                        altText
                        localFile {
                            childImageSharp {
                                gatsbyImageData
                            }
                        }
                    }
                }
                alljoboptionen {
                    woher {
                        text
                    }
                }
            }
        }
    }
`
